import { normalizeText } from "./domUtils";

const isEmployeeModalHeading = (heading) => {
  if (!heading) return false;
  const text = normalizeText(heading.textContent);
  return text === "editar colaborador" || text === "novo colaborador";
};

const nodeContainsEmployeeModal = (node) => {
  const element =
    node?.nodeType === Node.ELEMENT_NODE
      ? node
      : node?.parentElement || null;
  if (!element) return false;

  if (element.matches?.("h2") && isEmployeeModalHeading(element)) return true;
  return Array.from(element.querySelectorAll?.("h2") || []).some(
    isEmployeeModalHeading,
  );
};

export const mutationContainsEmployeeModal = (records) =>
  records.some((record) =>
    Array.from(record.addedNodes || []).some(nodeContainsEmployeeModal),
  );
